// extracted by mini-css-extract-plugin
export default {"listItem":"W7bXJf","title":"ZK3de8","subtitle":"Ifd1Sm"};